export const TB_SOMAR = 'somar'
export const TB_POTENCIA = 'potencia'
export const TB_LOJA = 'loja'
export const TB_IRMAO = 'irmao'
export const TB_CANDIDATO = 'candidato'
export const TB_CIDADE = 'cidade'
export const TB_PASTA = 'pasta'
export const TB_SERVICO = 'servico'
export const TB_EVENTO = 'evento'
export const TB_PRESENCA = 'presenca'
export const TB_HISTORICO_DE_DIRETORIA = 'historico-de-diretoria'
export const TB_LOG = 'log'
